import i18n from '@/i18n/config'
import { useEffect, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * Hook to manage HTML document direction (RTL/LTR) based on current language
 * Updates document.documentElement.dir attribute when language changes
 * Listens to both initial language and language change events
 */
export function useLanguageDirection() {
  const { i18n: i18nInstance } = useTranslation()

  const updateDirection = useCallback(() => {
    const language = i18nInstance.language || i18n.language || 'en'
    const direction = language === 'ar' ? 'rtl' : 'ltr'
    document.documentElement.dir = direction
    document.documentElement.lang = language
  }, [i18nInstance.language])

  useEffect(() => {
    // Set initial direction
    updateDirection()

    // Listen for language changes
    const handleLanguageChanged = () => {
      updateDirection()
    }

    // Subscribe to language change events
    i18n.on('languageChanged', handleLanguageChanged)

    // Cleanup
    return () => {
      i18n.off('languageChanged', handleLanguageChanged)
    }
  }, [updateDirection])
}

